import React from "react";
import { useFormik } from "formik";
import axios from "axios";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { adminMainUrl } from "../../../../../Config";

const BankDetailsEdit = ({ LedgerAccountDetail }) => {

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      banks:
        LedgerAccountDetail?.ledger_account_bank_details?.length > 0
          ? LedgerAccountDetail.ledger_account_bank_details.map((item) => ({
            ...item,
            confirm_account_number: item.account_number || "",
          }))
          : [
            {
              id: "",
              account_number: "",
              confirm_account_number: "",
              ifsc_code: "",
              bank_name: "",
              branch_address: "",
            },
          ],
    },

    onSubmit: async (values) => {

      // ✅ Validate account number match
      for (let i = 0; i < values.banks.length; i++) {
        const row = values.banks[i];

        if (row.account_number !== row.confirm_account_number) {
          toast.error(`Row ${i + 1}: Account numbers do not match`);
          return;
        }
      }

      try {

        const payload = {
          ledger_account_id: LedgerAccountDetail.id,
          bank: values.banks.map((row) => ({
            id: row.id,
            account_number: row.account_number,
            ifsc_code: row.ifsc_code,
            bank_name: row.bank_name,
            branch_address: row.branch_address,
          })),
        };

        await axios
          .post(
            `${adminMainUrl}/api/account/update-ledger-account-bank-details`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                "auth-token": Cookies.get("token"),
                user_id: Cookies.get("flexichain_user_id"),
              },
            }
          )
          .then((res) => {
            if (res.status === 200) {
              toast.success(res.data.msg);
            }
          })
          .catch((err) => {
            let err_msg = "Something went wrong."
            // console.log(err)
            if (err && err.response && err.response.data && err.response.data.msg) {
              err_msg = err.response.data.msg;
            }
            toast.error(err_msg);
          });

      } catch {
        toast.error("Update failed");
      }
    },
  });

  // ✅ Add new row
  const addBank = () => {
    formik.setFieldValue("banks", [
      ...formik.values.banks,
      {
        id: "",
        account_number: "",
        confirm_account_number: "",
        ifsc_code: "",
        bank_name: "",
        branch_address: "",
      },
    ]);
  };

  // ✅ Remove row
  const removeBank = (index) => {
    if (formik.values.banks.length > 1) {
      const updated = [...formik.values.banks];
      updated.splice(index, 1);
      formik.setFieldValue("banks", updated);
    }
  };

  return (
    <form onSubmit={formik.handleSubmit}>

      {formik.values.banks.map((bank, index) => (

        <div key={index} className="border p-3 mb-3">

          <div className="row">

            {/* Account Number */}
            <div className="col-md-4 mb-3">
              <label className="form-label">Account Number *</label>
              <input
                type="text"
                className="form-control"
                name={`banks.${index}.account_number`}
                value={bank.account_number}
                onChange={formik.handleChange}
              />
            </div>

            {/* Confirm Account Number */}
            <div className="col-md-4 mb-3">
              <label className="form-label">Confirm Account Number *</label>
              <input
                type="text"
                className="form-control"
                name={`banks.${index}.confirm_account_number`}
                value={bank.confirm_account_number}
                onChange={formik.handleChange}
              />
            </div>

            {/* IFSC */}
            <div className="col-md-4 mb-3">
              <label className="form-label">IFSC Code *</label>
              <input
                type="text"
                className="form-control"
                name={`banks.${index}.ifsc_code`}
                value={bank.ifsc_code}
                onChange={formik.handleChange}
              />
            </div>

            {/* Bank Name */}
            <div className="col-md-4 mb-3">
              <label className="form-label">Bank Name *</label>
              <input
                type="text"
                className="form-control"
                name={`banks.${index}.bank_name`}
                value={bank.bank_name}
                onChange={formik.handleChange}
              />
            </div>

            {/* Branch Address */}
            <div className="col-md-8 mb-3">
              <label className="form-label">Branch Address</label>
              <input
                type="text"
                className="form-control"
                name={`banks.${index}.branch_address`}
                value={bank.branch_address}
                onChange={formik.handleChange}
              />
            </div>
          </div>
          <div className="row">
            <div>
              <button
                style={{ float: "right" }}
                type="button"
                className="btn btn-danger mt-2 btn-sm"
                onClick={() => removeBank(index)}
              >
                Delete Bank
              </button>
            </div>
          </div>

        </div>
      ))}

      <button
        type="button"
        className="btn btn-primary btn-sm"
        onClick={addBank}
      >
        + Add More Bank
      </button>

      <div className="mt-4">
        <button type="submit" className="btn btn-primary" style={{ float: "right" }}>
          Save
        </button>
      </div>

    </form>
  );
};

export default BankDetailsEdit;